import React from 'react';

const WhatsAppButton = () => {
  return (
    <>
      <style jsx>{`
       .whatsapp-button {
  position: fixed;
  bottom: 25px;
  right: 18px;
  z-index: 559;
  width: 47px;          /* reduced from 70px */
  height: 47px;         /* reduced from 70px */
  border-radius: 50%;
  background: #25d366;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: pulse 2.5s infinite;
}

.whatsapp-button:hover {
  transform: scale(1.1);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.35);
}

.whatsapp-button img {
  width: 28px;         /* scaled down with button */
  height: 28px;
  filter: drop-shadow(0 1px 1px rgba(0,0,0,0.2));
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 15px rgba(37, 211, 102, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
}

      `}</style>

      <a
        href="https://wa.me/918005885520"
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
        />
      </a>
    </>
  );
};

export default WhatsAppButton;
